import Vue from 'vue';
import VueRouter from 'vue-router';
import ChainPage from '../views/ChainPage.vue';
import NodePage from '../views/NodePage.vue';
import AlertsPage from '../views/AlertsPage.vue';
import AlertPage from '../views/AlertPage.vue';
import HomePage from '../views/HomePage.vue';
import IngestorPage from '../views/IngestorPage.vue';
import SetupPage from '../views/SetupPage.vue';
import ChainsJsonPage from '../views/ChainsJsonPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: AlertsPage,
  },
  {
    path: '/alert',
    name: 'Alert',
    component: AlertPage,
  },
  {
    path: '/ingestor/:ingestor',
    name: 'Ingestor',
    component: IngestorPage,
  },
  {
    path: '/chain/:chain',
    name: 'Chain',
    component: ChainPage,
  },
  {
    path: '/node/:chain/:node',
    name: 'Node',
    component: NodePage,
  },
  {
    path: '/setup',
    name: 'Setup',
    component: SetupPage,
  },
  {
    path: '/json-status',
    name: 'JsonStatus',
    component: ChainsJsonPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
